import venueVenues from './modules/venueVenues';
import venueLocationMap from './modules/venueLocationMap';

export default {
  init() {
    venueVenues();
  },
  finalize() {
    venueLocationMap();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelVenueWeddings.js